import * as types from '../types.js'
export default {
	[types.MAKE_GET_SEO]:state => {
		return state.seoInfo;
	}
}


// WEBPACK FOOTER //
// ./src/store/asset/getters.js